import React from 'react';
import { GridPagination } from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import { ActionContext } from '../../context/ActionContext';
import { baseFontFamilyStyle } from '../../shared/styles';
import { PAGE_LIMIT } from '../../shared/Constants';

const CustomPagination = (totalResults, handlePaginationModelChange, currentOfficeTheme, otherProps) => {
	const { activeNode, pageInfo } = React.useContext(ActionContext);

	// Sub Components
	const Pagination = React.useCallback(
		({ page, onPageChange, className, otherProps }) => {
			return (
				<MuiPagination
					color="primary"
					aria-label="Pagingation"
					aria-current={page + 1}
					size="small"
					showFirstButton
					showLastButton
					className={className}
					count={Math.ceil(totalResults / PAGE_LIMIT)}
					page={page + 1}
					onChange={(event, newPage) => {
						onPageChange(event, newPage - 1);
					}}
					sx={{
						'.MuiPaginationItem-root': {
							color: currentOfficeTheme.bodyForegroundColor,
						},
						button: { color: currentOfficeTheme.bodyForegroundColor, fontFamily: baseFontFamilyStyle },
					}}
					{...otherProps}
				/>
			);
		},
		[totalResults, currentOfficeTheme],
	);

	return (
		<GridPagination
			ActionsComponent={e => {
				return (
					<Pagination
						{...e}
						page={pageInfo[activeNode]?.num || 0}
						onPageChange={(e, page) => handlePaginationModelChange(page)}
					/>
				);
			}}
			{...otherProps}
			style={{ overflow: 'hidden' }}
		/>
	);
};

export default CustomPagination;
